'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useMemo, Children, isValidElement, cloneElement } from 'react';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { BreadcrumbList } from './breadcrumb-list.component.js';
import { useId } from '../../hooks/use-id.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, e) {
    if (null == r) return {};
    var o, t, n = _object_without_properties_loose(r, e);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(r);
        for(t = 0; t < s.length; t++)o = s[t], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(r, o) && (n[o] = r[o]);
    }
    return n;
}
function _object_without_properties_loose(r, e) {
    if (null == r) return {};
    var o, t, n = {}, s = Object.keys(r);
    for(t = 0; t < s.length; t++)o = s[t], e.indexOf(o) >= 0 || (n[o] = r[o]);
    return n;
}
const Breadcrumbs = renderWithRef('Breadcrumbs', null, (a, f)=>{
    let h = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('Breadcrumbs', a, [
        {
            propName: 'accessibleTextForMore',
            instructions: getDeprecatedI18nPropMessage(h)
        }
    ]);
    let { accessibleTextForMore: _, children: w } = a, j = _object_without_properties(a, [
        "accessibleTextForMore",
        "children"
    ]), [x, v] = useState(false), y = useRef(null), O = useId(), g = useMemo(()=>{
        let r = Children.map(w, (r, e)=>{
            if (isValidElement(r) && O) {
                var o;
                let n = null !== (o = r.props.id) && void 0 !== o ? o : `${O}-${e}`;
                return 1 === e ? cloneElement(r, {
                    id: n,
                    ref: y
                }) : cloneElement(r, {
                    id: n
                });
            }
            return r;
        });
        return Children.toArray(r);
    }, [
        w,
        O
    ]), k = useMemo(()=>g.map((r)=>isValidElement(r) ? r.props.id : null), [
        g
    ]), M = _;
    function showMore() {
        v(true), setTimeout(()=>{
            var r;
            if (!y.current) return;
            let e = y.current;
            (null === (r = e.children) || void 0 === r ? void 0 : r.length) > 0 && e.children[0].focus();
        }, 500);
    }
    return h && !M && (M = h.t('breadcrumbs.accessible-text-for-more-button')), jsx(RenderComp, {
        root: "nav",
        forwardedRef: f,
        classNames: [
            'swan-breadcrumbs'
        ],
        props: j,
        children: M && k.length > 4 ? jsxs(BreadcrumbList, {
            className: x ? '' : 'swan-breadcrumbs-collapsed',
            children: [
                g[0],
                jsx("li", {
                    className: "swan-breadcrumbs-button-more",
                    children: jsx("button", {
                        "aria-label": M,
                        "aria-expanded": "false",
                        onClick: showMore,
                        "aria-controls": k.slice(1, -2).join(' '),
                        children: "..."
                    })
                }),
                g.slice(1)
            ]
        }) : jsx(BreadcrumbList, {
            children: g
        })
    });
});

export { Breadcrumbs };
